import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import YagiprimeWrapper from '@/components/Payment/YagiprimeWrapper.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoAiReason } from '@/composables/format-edit/useRirekishoAiReason'
import hopeIndustryOptions from '@/utils/format-edit/rirekishoHopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/rirekishoHopeJobcategoryOptions.json'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoAiReasonCard',
  props: {
    currentCardId: null,
    basicData: null,
    previewErrors: null,
    textareaMinRows: null,
    aiGateFeature: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  basicData: BasicData
  previewErrors: Record<string, string>
  textareaMinRows: number
  /** Ai career 用。指定時は生成前に useFeature ゲート */
  aiGateFeature?: string
};



const formatData = useRirekishoFormatData()
const {
  globalVar,
  fullscreenLoading,
  loadingText,
  aiResultView,
  aiResultMyprResult,
  aiResultReasonResult,
  viewYagiprimepayment,
  completeBuyYagiprime,
  matchingCompany,
  isMatching,
  getLicences,
  viewPaymentYagiprime,
  skipAiContinueFree,
  getAIMypr,
  applyAgent,
  useAiMyprResult,
  useAiReasonResult
} = useRirekishoAiReason(formatData, {
  gateFeature: props.aiGateFeature
})

const inAppPayments = computed(
  () => !!(globalVar as { in_app_payments?: boolean }).in_app_payments
)

return { __sfc: true,props, formatData, globalVar, fullscreenLoading, loadingText, aiResultView, aiResultMyprResult, aiResultReasonResult, viewYagiprimepayment, completeBuyYagiprime, matchingCompany, isMatching, getLicences, viewPaymentYagiprime, skipAiContinueFree, getAIMypr, applyAgent, useAiMyprResult, useAiReasonResult, inAppPayments, YagiprimeWrapper, hopeIndustryOptions, hopeJobcategoryOptions }
}

})